import * as React from 'react'
import { FC } from 'react'
import DottedRectangles from '../DottedRectangles/DottedRectangles'
import { cls } from '../../utils/utils'
import { TextColors } from '../../utils/constants'
import { Parallelepiped } from '../Parallelepiped/Parallelepiped'
import { IParallelepipedColor } from '../Parallelepiped/Parallelepiped.types'
import { BackgroundColorType } from '../../utils/constants'
import ReadyToTalk from './components/ReadyToTalk/ReadyToTalk'
import * as styles from './Section.module.scss'
import { ISectionProps } from './Section.types'

const parallelepipedColors: Record<BackgroundColorType, IParallelepipedColor> = {
  white: 'grey',
  grey: 'white',
  dark: 'black',
}

const Section: FC<ISectionProps> = (props) => {
  const style = {
    backgroundImage: `url(${props.background?.image?.publicURL})`,
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: props.background?.positionX,
    backgroundPositionY: props.background?.positionY,
  }

  const pdColor = props.parallelepipedColor || 'white'

  return (
    <section
      id={props.anchor}
      style={props.background ? style : {}}
      className={cls(
        styles[`${props.backgroundColor || 'white'}Section`],
        props.hideBottomPadding ? styles.dontShowPadding : styles.showUpperPadding,
        styles.section
      )}
    >
      {!props.dontShowParallelepiped && <Parallelepiped color={parallelepipedColors[pdColor]} />}
      <div className="main-container">
        <div
          className={cls(
            styles.content,
            !props.hideBottomPadding && styles.showLowerPadding,
            !props.hidePaddingForReady && styles.showLowerPadding
          )}
        >
          {props.children}
        </div>
        {props.readyToTalkStyle && (
          <ReadyToTalk
            colorTitle={props.backgroundColor === 'dark' ? TextColors.WHITE : TextColors.DARK}
            btnStyle={props.readyToTalkStyle}
            readyToTalkText={props.readyToTalkText}
          />
        )}
        {props.rectanglesColor && props.rectanglesColor.trim() && <DottedRectangles color={props.rectanglesColor} />}
      </div>
    </section>
  )
}

export default Section
